import { List,Record } from "immutable";

import { LAYOUT_VIEW,MIXED_VIEWS, ORIENTATION_ROW } from "../../../../constants/identifiers";
import createFromJS from "../../../createFromJS";
import { SizeRecord } from "../../helper/SizeRecord";

export const ViewLayoutDisplayRecord = Record({
  orientation: ORIENTATION_ROW,
  children: List(),
  viewType: LAYOUT_VIEW,
  childViewTypes: MIXED_VIEWS,
  size: SizeRecord(),
  minSize: SizeRecord(),
  scrollSync: false
});

const data = {
  objects: {
    size: "SizeRecord",
    minSize: "SizeRecord",
    children: "List"
  }
};
createFromJS.registerCallback(
  "ViewLayoutDisplayRecord",
  createFromJS.createNestedCallback(ViewLayoutDisplayRecord, data)
);
